import React from 'react';
import './home.scss';
import { Hero } from '../../icon/icons';
import { Container} from 'react-bootstrap';
import { Select, OfferCards , NewsCard, SuccessStories } from '../../components';
import { images } from '../../utils/customFn';

const Home = () => {

  const Selectoptions = [
    { value: 'Constructions', label: 'Constructions' },
    { value: 'DealerShip', label: 'DealerShip' },
    { value: 'Manufacturing and process industries', label: 'Manufacturing and process industries' },
    { value: 'Retailers and Distributors', label: 'Retailers and Distributors' },
    { value: 'Service industries', label: 'Service industries' },
    { value: 'Trucking', label: 'Trucking' },
  ];

  const NewsCardData = [
    {
      id: 1,
      title: '2024 Retail & Wholesale Injury Report: Protecting new hires',
      description:
        'Our new report shows higher injury rates among first-year workers in retail and wholesale operations. Dan Grant and Jean Feldman share their tips and insights.',
      linkUrl: '',
      linkText: 'Learn more >',
    },
    {
      id: 2,
      title: 'Sentry employees raise $1.7 million for United Way',
      description:
        'Sentry Insurance employees come together during their annual United Way campaign, raising $1.7 million to support their communities.',
      linkUrl: '/',
      linkText: 'Learn more >',
    },
    {
      id: 3,
      title: 'Innovative optionsDeloitte ranks Sentry No. 13 on Wisconsin 75',
      description:
        'Sentry moved up one spot on the 2024 Wisconsin 75. Its success reflects a long-term growth strategy, forecast to continue in 2025.',
      linkUrl: '/',
      linkText: 'Learn more >',
    },
  ];

  const offerCardData = [
    {
        id: 1,
        imageUrl:
            images["talking-chat-bubbles-card.svg"],
        title: 'Expert conversations',
        description:
            'At Sentry, we’ve built our reputation on listening and providing assistance to all of our business customers. It’s in our DNA. And has been for more than 120 years.',
        linkUrl: '/contact-us',
        linkText: 'Give us a call—let’s talk',
    },
    {
        id: 2,
        imageUrl:
            images["helping-climb-blue-card.svg"],
        title: 'Dedicated service',
        description:
            'Every company needs insurance protection for when things go wrong. But if you’re like us, you know there’s a bigger picture. We’re here to help you find the right coverage, manage claims, and develop a proactive safety culture to minimize risks.',
        linkUrl: '/solutions',
        linkText: 'Let us be your guide',
    },
    {
        id: 3,
        imageUrl:
            images["guidance-telescope-card.svg"],
        title: 'Innovative options',
        description:
            'Let’s face it. Insurance is not a one-size-fits-all solution. At least not here at Sentry. We get to know you and your business, offering innovative solutions that make sense for you.',
        linkUrl: '/about-us',
        linkText: 'Together, we can make it happen',
    },
  ];


  return (
    <div className='home-page-wrapper'>
      {/* Hero section */}
      <section className='hero-section-top'>
        <div className='banner-img'>
        <picture>
          <source srcSet={images['M_Hero-2.avif']} media="(max-width: 768px)" />
          <Hero />
        </picture>
          
        </div>
        <Container>
          <div className='hero-title homepage'>
            <h1>Your business. Our experience.</h1>
          </div>
        </Container>
        <Container>
          <div className='industry-dropdown'>
            <h2>I’m interested in products for</h2>
            <Select options={Selectoptions} />
          </div>
        </Container>
      </section>
      {/* we offer */}
      <OfferCards heading="We’ll offer you" data={offerCardData}/>
      <Container>
        {/* success stories */}
        <SuccessStories/>
         {/* all new List */}
        <NewsCard Title='News and thought leadership' CardData={NewsCardData}/>
      </Container>
    </div>
  );
};

export default Home;
